import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBagIcon } from 'lucide-react';
const NAMES = ['Alejandro', 'María', 'Juan Pablo', 'Valentina', 'Nicolás', 'Camila', 'Federico', 'Florencia', 'Matías', 'Paula', 'Gonzalo', 'Romina', 'Sebastián', 'Agustina', 'Tomás', 'Daniela', 'Facundo', 'Milagros', 'Leandro', 'Carolina'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'San Miguel de Tucumán', 'Mar del Plata', 'Salta', 'Santa Fe', 'San Juan', 'Resistencia', 'Neuquén', 'Posadas', 'Bahía Blanca', 'Paraná'];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentName, setCurrentName] = useState('');
  const [currentCity, setCurrentCity] = useState('');
  useEffect(() => {
    const showPopup = () => {
      const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
      const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
      setCurrentName(randomName);
      setCurrentCity(randomCity);
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    };
    // Initial delay
    const initialTimer = setTimeout(showPopup, 5000);
    // Subsequent random intervals between 8 and 15 seconds
    const intervalId = setInterval(() => {
      if (!isVisible) {
        setTimeout(showPopup, Math.random() * 7000 + 8000);
      }
    }, 15000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(intervalId);
    };
  }, [isVisible]);
  return <AnimatePresence data-id="element-102">
      {isVisible && <motion.div initial={{
      opacity: 0,
      x: -100
    }} animate={{
      opacity: 1,
      x: 0
    }} exit={{
      opacity: 0,
      x: -100
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 25
    }} className="fixed bottom-4 left-4 z-50 bg-navy-light border border-gold/30 rounded-lg shadow-2xl p-4 max-w-sm flex items-center gap-4" data-id="element-103">
          <div className="bg-gold/20 p-2 rounded-full" data-id="element-104">
            <ShoppingBagIcon className="w-6 h-6 text-gold" data-id="element-105" />
          </div>
          <div data-id="element-106">
            <p className="text-sm text-gray-300" data-id="element-107">
              <span className="font-bold text-white" data-id="element-108">{currentName}</span> de{' '}
              {currentCity}
            </p>
            <p className="text-xs text-gold font-medium mt-1" data-id="element-109">
              acaba de comprar Estudio Jurídico Listo
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}